import { getLogger } from '@cian/logger/browser';
import loadable from '@loadable/component';
import { NO_SSR } from 'shared/constants/loadable';

import type { IPurchaseGiftModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import type * as React from 'react';

interface IPurchaseGiftModalModule {
  PurchaseGiftModal: React.ComponentType<IPurchaseGiftModalProps>;
}

/* istanbul ignore next */
export const NewbuildingPurchaseGiftModalLoadable = loadable(
  () =>
    import('@cian/frontend-newbuilding-promo-modal-widget')
      .then((module): IPurchaseGiftModalModule => module)
      .catch((error): IPurchaseGiftModalModule => {
        getLogger().warning(error, {
          domain: 'loadable.chunkLoadFailed',
          message: 'Не удалось загрузить чанк модалки акции «30 000 ₽ за покупку квартиры»',
        });

        return { PurchaseGiftModal: () => null };
      }),
  {
    resolveComponent: (module: IPurchaseGiftModalModule) => module.PurchaseGiftModal,
    ssr: NO_SSR,
  },
);
